import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.function.name.js";
import React from 'react';
import isMultiDomain from 'utils/isMultiDomain';
import Stack from 'components/Stack';
import UnsavedChangesPrompt from 'components/UnsavedChangesPrompt';
import GeneralDetailsCard from './Cards/GeneralDetailsCard';
import AdvancedSettingsCard from './Cards/AdvancedSettingsCard';
import LinkDetailsCard from './Cards/LinkDetailsCard';
import FileDetailsCard from './Cards/FileDetailsCard';
import FormWrapper from './FormWrappers';
var AssetDetailsModal = function AssetDetailsModal(_ref) {
  var _ref$isEditMode = _ref.isEditMode,
    isEditMode = _ref$isEditMode === void 0 ? false : _ref$isEditMode,
    isNewFile = _ref.isNewFile,
    isProcessingError = _ref.isProcessingError,
    isLoading = _ref.isLoading,
    isSubmitDisabled = _ref.isSubmitDisabled,
    inContentManagerContext = _ref.inContentManagerContext,
    hasChanges = _ref.hasChanges,
    showUploadProgress = _ref.showUploadProgress,
    fields = _ref.fields,
    uploadProgress = _ref.uploadProgress,
    assetContentType = _ref.assetContentType,
    content = _ref.content,
    aiSuggestions = _ref.aiSuggestions,
    onReplace = _ref.onReplace,
    onDelete = _ref.onDelete,
    onSubmit = _ref.onSubmit,
    onClose = _ref.onClose,
    resetValues = _ref.resetValues;
  var isDistributed = isMultiDomain(content);
  var initialAssetDetails = {
    author: content === null || content === void 0 ? void 0 : content.author,
    createdTime: content === null || content === void 0 ? void 0 : content.createdTime,
    lastUpdated: content !== null && content !== void 0 && content.lastUpdated ? new Date(content === null || content === void 0 ? void 0 : content.lastUpdated).toISOString() : undefined
  };
  function handleSubmit() {
    return _handleSubmit.apply(this, arguments);
  }
  function _handleSubmit() {
    _handleSubmit = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return onSubmit();
          case 2:
            resetValues();
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _handleSubmit.apply(this, arguments);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(UnsavedChangesPrompt, {
    hasUnsavedChanges: hasChanges,
    includeQueryParams: false
  }), /*#__PURE__*/React.createElement(FormWrapper, {
    isEditMode: isEditMode,
    isLoading: isLoading,
    isSubmitDisabled: isSubmitDisabled,
    inContentManagerContext: inContentManagerContext,
    name: fields.name.value,
    hasChanges: hasChanges,
    onSubmit: handleSubmit,
    onDiscard: resetValues,
    onClose: onClose
  }, /*#__PURE__*/React.createElement(Stack, {
    spacing: "m"
  }, /*#__PURE__*/React.createElement(GeneralDetailsCard, {
    isEditMode: isEditMode,
    isDistributed: isDistributed,
    fields: fields,
    content: content,
    aiSuggestions: aiSuggestions,
    assetContentType: assetContentType,
    initialAssetDetails: initialAssetDetails
  }), /*#__PURE__*/React.createElement(AdvancedSettingsCard, {
    isDistributed: isDistributed,
    assetContentType: assetContentType,
    fields: fields,
    content: content
  }), assetContentType === 'web' ? /*#__PURE__*/React.createElement(LinkDetailsCard, {
    isDistributed: isDistributed,
    fields: fields
  }) : /*#__PURE__*/React.createElement(FileDetailsCard, {
    isNewFile: isNewFile,
    isProcessingError: isProcessingError,
    isEditMode: isEditMode,
    isDistributed: isDistributed,
    showUploadProgress: showUploadProgress,
    uploadProgress: uploadProgress,
    onReplace: onReplace,
    onDelete: onDelete,
    content: content
  }))));
};
export default AssetDetailsModal;